import {
    CORE_LANGUAGES,
    LANGUAGE_MODULE_MAP,
    LANGUAGE_DEPENDENCIES
} from './config';

const LANGUAGE_ALIASES = {
    js: 'javascript',
    ts: 'typescript',
    py: 'python',
    rb: 'ruby',
    html: 'markup',
    xml: 'markup',
    sh: 'bash',
    shell: 'bash',
    yml: 'yaml',
    md: 'markdown',
    csharp: 'cs',
    cpp: 'c'
    // Add more as needed
};

const extractLang = (el) => {
    const classes = el.className.split(' ');
    const langClass = classes.find((cls) => cls.startsWith('language-'));

    return langClass?.replace('language-', '');
};

const loadLang = async (lang) => {
    // Map aliases to canonical Prism language
    const canonicalLang = LANGUAGE_ALIASES[lang] || lang;

    // Skip plaintext since it's just the fallback
    if (canonicalLang === 'plaintext') {
        return;
    }

    // Skip loading for core languages that aren't dependencies
    if (
        CORE_LANGUAGES.includes(canonicalLang) &&
        !LANGUAGE_MODULE_MAP[canonicalLang]
    ) {
        return;
    }

    // Get dependencies for this language
    const dependencies = LANGUAGE_DEPENDENCIES[canonicalLang] || [];

    // Load dependencies first
    for (const dep of dependencies) {
        await loadLang(dep);
    }

    // Then load the language itself
    const loader = LANGUAGE_MODULE_MAP[canonicalLang];
    if (loader) {
        try {
            await loader();
        } catch (err) {
            console.warn(
                `Failed to load Prism language '${canonicalLang}':`,
                err
            );
        }
    }
};

export {extractLang, loadLang};
